import React, {useRef, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Divider, message, Modal, PageHeader, Space} from 'antd';
import _ from 'lodash';

import {ClockCircleOutlined, FileTextTwoTone, SendOutlined} from '@/icons';
import {saveFiexedTimeMessage, sendMessage} from '@/api/message';

import MessageContent from '@/page/app/component/MessageContent';
import SendArea from './SendArea';
import {convertTos, isEmptySelData} from './utils';
import {byteLength} from '@/util/stringUtils';
import FixedTimeModal from './FixedTimeModal';

const MAX_CONTENT_BYTE_LENGTH = 2048;

export default function MsgSendPanel() {
    const contentRef = useRef();
    const sendRef = useRef();
    const fixedTimeModalRef = useRef();

    const navigate = useNavigate();

    const [submiting, setSubmiting] = useState(false);

    const {appId} = useParams();

    function checkMessage() {
        const {msgType, safe, content} = contentRef.current.getData();
        const {toAll, tos, toUserCount} = sendRef.current.getData();

        // console.log('optional', tos?.departs);
        // console.log('optional', tos?.users ?? 'users');
        // console.log();
        console.log({toAll, tos, toUserCount});
        // console.log(msgType);
        // console.log('safe', safe);
        console.log(content);

        if (!toAll && isEmptySelData(tos)) {
            message.warn('「发送范围」不能为空');
            return false;
        }

        if (_.isEmpty(content)) {
            message.warn('「消息内容」不能为空');
            return false;
        }

        if (msgType === 'text' && byteLength(content.content) > MAX_CONTENT_BYTE_LENGTH) {
            message.warn(`文本内容不能超过 ${MAX_CONTENT_BYTE_LENGTH} 字节`);
            return false;
        }

        return {toAll, tos, toUserCount, msgType, safe, content};
    }

    function onFixedTimeClick() {
        const data = checkMessage();
        if (!data) {
            return;
        }
        console.log('.....', data);

        fixedTimeModalRef.current.showModal();
    }

    function onFixedTimeChange(timestamp) {
        console.log(timestamp);
        const data = checkMessage();
        if (!data) {
            return false;
        }

        const {toAll, tos, toUserCount, msgType, safe, content} = data;
        const values = {
            toAll,
            tos: toAll ? null : convertTos(tos),
            toUserCount,
            msgType,
            safe,

            fixedTimeMsg: true,
            fixedTime: timestamp,

            message: content,
            newsContents: content.newsContents,
        };
        console.table(values);

        return saveFiexedTimeMessage(appId, values).then(data => {
            console.log(data);
            message.success('定时任务保存成功');
            contentRef.current.setEditDirty(false);

            navigate(`/apps/${appId}/msg-history/send`);
        });
    }

    function onSendClick() {
        const data = checkMessage();
        if (!data) {
            return;
        }
        console.log('111122222', data);
        const {toAll, tos, toUserCount, msgType, safe, content} = data;
        Modal.confirm({
            title: '提示',
            content: '确定要发送消息？',
            okText: '确定发送',
            onOk: () => {
                sendMessage2Wecom(toAll, tos, toUserCount, msgType, safe, content);
            },
        });
    }

    function sendMessage2Wecom(toAll, tos, toUserCount, msgType, safe, content) {
        setSubmiting(true);
        const values = {
            toAll,
            tos: toAll ? null : convertTos(tos),
            toUserCount,
            msgType,
            safe,
            message: content,
            newsContents: content.newsContents,
        };
        console.table(values);

        sendMessage(appId, values)
            .then(data => {
                console.log(data);
                message.success('发送成功');
                contentRef.current.setEditDirty(false);

                navigate(`/apps/${appId}/msg-history/send`);
            })
            .catch(() => {
                setSubmiting(false);
            });
    }

    return (
        <div style={{maxWidth: 900, marginLeft: 24}}>
            <PageHeader
                title="发送消息"
                avatar={{icon: <FileTextTwoTone />, style: {backgroundColor: '#e6f7ff'}}}
                style={{paddingLeft: 10}}
            />

            <SendArea ref={sendRef} appId={appId} />

            <MessageContent ref={contentRef} style={{marginBottom: 24}} />

            <Divider />

            <Space size="large">
                <Button
                    type="primary"
                    icon={<SendOutlined />}
                    loading={submiting}
                    disabled={submiting}
                    onClick={onSendClick}
                >
                    发送
                </Button>
                <Button icon={<ClockCircleOutlined />} onClick={onFixedTimeClick}>
                    定时发送
                </Button>
            </Space>

            <FixedTimeModal ref={fixedTimeModalRef} okText="发送" onChange={onFixedTimeChange} />
        </div>
    );
}
